import * as React from 'react';
import { LineChart, lineElementClasses } from '@mui/x-charts/LineChart';
import { useData } from 'components/provider/data';
import dayjs from 'dayjs';
import { Button, ConfigProvider, Select } from 'antd';
import { useTheme } from 'components/provider/theme';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import { BarChart, legendClasses } from '@mui/x-charts';

const TradeHistoryChartBar = () => {
    const { tradeHistoryChartData } = useData();
    const { theme } = useTheme();
    const [range, setRange] = React.useState([0, 100]);
    const [data, setData] = React.useState(tradeHistoryChartData);
    const [selectedLabel, setSelectedLabel] = React.useState<string[]>(tradeHistoryChartData[0]?.label ? [tradeHistoryChartData[0].label] : []);
    const [dataBaseOnWeek, setDataBaseOnWeek] = React.useState(
        (() => {
            // Group data points by day of week (0: Sunday, 6: Saturday)
            const weekData: { [key: number]: any[] } = {};
            tradeHistoryChartData.forEach(item => {
                item.data.forEach(point => {
                    const dayOfWeek = dayjs(point.x).day();
                    if (!weekData[dayOfWeek]) weekData[dayOfWeek] = [];
                    weekData[dayOfWeek].push(point);
                });
            });
            return weekData;
        })()
    );
    React.useEffect(() => {
        setData(tradeHistoryChartData);
        setDataBaseOnWeek((() => {
            // Group data points by day of week (0: Sunday, 6: Saturday)
            const weekData: { [key: number]: any[] } = {};
            tradeHistoryChartData.forEach(item => {
                item.data.forEach(point => {
                    const dayOfWeek = dayjs(point.x).day();
                    if (!weekData[dayOfWeek]) weekData[dayOfWeek] = [];
                    weekData[dayOfWeek].push(point);
                });
            });
            return weekData;
        })());
    }, [tradeHistoryChartData]);

    // Apply range to data
    const rangedData = data.map((item) => ({
        ...item,
        data: item.data.slice(range[0], range[1]),
    }));

    return (
        <div className="col-span-5">
            <BarChart
                height={300}
                series={dataBaseOnWeek ? [{
                    label: 'Total P&L per Weekday',
                    data: Object.keys(dataBaseOnWeek).map(day => dataBaseOnWeek[parseInt(day, 10)].reduce((sum, point) => sum + point.y, 0)),
                }] : []}
                xAxis={[{
                    scaleType: 'band',
                    data: Object.keys(dataBaseOnWeek || {}).map(day => {
                        const dayNum = parseInt(day, 10);
                        // Convert day number to weekday name
                        return dayjs().day(dayNum).format('dddd');
                    }),
                    valueFormatter: (value, context) => {
                        return `${value} `;
                    },


                }]}

                hideLegend
                yAxis={[{ width: 50 }]}
                sx={(themes) => ({
                    [`.${axisClasses.root}`]: {
                        [`.${axisClasses.tick}, .${axisClasses.line}`]: {
                            stroke: theme === 'dark' ? '#fff' : '#000',
                            strokeWidth: 1,
                        },
                        [`.${axisClasses.tickLabel}`]: {
                            fill: theme === 'dark' ? '#fff' : '#000',
                        },
                    },

                })}
            />
        </div>
    )
}

export default TradeHistoryChartBar;